/** Googleova skripta koja crta gumb i vodi odabir računa. */
export const GOOGLE_SCRIPT_URL = "https://accounts.google.com/gsi/client";

/** Identifikator naše aplikacije kod Googlea; bez njega se prijava ne nudi. */
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID ?? "";

/** Izgled gumba — širina se postavlja u pikselima, jer Google ne prihvaća postotke. */
export const GOOGLE_BUTTON_CONFIG = {
  type: "standard",
  theme: "outline",
  size: "large",
  shape: "rectangular",
  text: "signin_with",
  locale: "hr",
  width: 400,
};
